import {AlternateUrl} from "@app/presentation/services/seo/seo.service";
import {Injectable} from "@angular/core";
import {ProductDetails} from "@app/core/product/domain/dtos/product-details";
import {UrlService} from "@app/presentation/services/url.service";
import {PromotionDetail} from "@app/core/promotion/domain/dtos/promotion-detail";


type Lang = 'es' | 'en' | 'pt' | 'fr';

type factoryType = (factoryParams: {lang: Lang, translatedSlug: string}) => string;

@Injectable({
    providedIn: 'root'
})
export class AlternateRoutes {

    constructor(
        private urlService: UrlService
    ) {}

    private getAlternateRoutes(factory: factoryType ,slugTranslations: Record<Lang, string>) {
        return Object.entries(slugTranslations).map(([lang,translatedSlug]) => {
            return {
                href: factory({lang: lang as Lang, translatedSlug: translatedSlug }),
                hrefLang: lang,
            }
        });
    }

    catalog(categoryCode: string): AlternateUrl[] {
        const slugTranslations = {
            'es': 'catalogo',
            'en': 'catalog',
            'pt': 'catalogo',
            'fr': 'catalogue'
        };
        return this.getAlternateRoutes(
            ({lang, translatedSlug}) => `${lang}/${translatedSlug}/${categoryCode}/`,
            slugTranslations,
        )
    }

    promotionDetail(params: { promotion: PromotionDetail }) {
        const { promotion } = params;
        const slugTranslations = {
            'es': 'promocion',
            'en': 'promotion',
            'pt': 'promoção',
            'fr': 'promotion'
        };
        return this.getAlternateRoutes(
            ({lang, translatedSlug}) => `${lang}/${translatedSlug}/${promotion.code}/`,
            slugTranslations,
        )
    }

    productDetail(params: { product: ProductDetails }) {
        const { product } = params;
        const slugTranslations = {
            'es': 'producto',
            'en': 'product',
            'pt': 'producto',
            'fr': 'produit'
        };
        const seoFriendlyName = this.urlService.createSeoFriendlySlug(product.name);
        return this.getAlternateRoutes(
            ({lang, translatedSlug}) => `${lang}/${translatedSlug}/${product.code}/${seoFriendlyName}/`,
            slugTranslations,
        )
    }
}
